import { render, staticRenderFns } from "./EventHighlightsIcon.vue?vue&type=template&id=c46ba236"
import script from "./EventHighlightsIcon.vue?vue&type=script&lang=ts"
export * from "./EventHighlightsIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports